import { SunSailType } from "@biz/definitions/SunSailDefinitions";
import { Measure } from "@biz/logic/Measure";

export class ProtectiveCoverLogic {
  // sync with app ... coverExtraLength
  static calcProtectiveCoverLengthAdd(sunSailType: SunSailType): number {
    switch (sunSailType) {
      case SunSailType.SolidayA:
      case SunSailType.SolidayM:
      case SunSailType.SolidayOne:
      case SunSailType.SolidayFlex:
        return 0.5;
      case SunSailType.SolidayCS:
      case SunSailType.SolidayTwin:
        return 0.25;
      case SunSailType.SolidayX:
      case SunSailType.SolidayXS:
      case SunSailType.SolidayC:
        return 0.25;
    }
    throw new Error("Protective Cover calculation not handled for: " + sunSailType);
  }

  static calcProtectiveCoverLengthText(topAxleLength: number, sunSailType: SunSailType): string {
    return Measure.toMM(topAxleLength + ProtectiveCoverLogic.calcProtectiveCoverLengthAdd(sunSailType));
  }

  static calcCoverLength(sunSailType: SunSailType, logicalAxleLength: number): number {
    return Math.ceil(logicalAxleLength + ProtectiveCoverLogic.calcProtectiveCoverLengthAdd(sunSailType));
  }
}